import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as FileSaver from 'file-saver';
import { AttendanceDetailComponent } from '../attendance-detail/attendance-detail.component';

@Component({
  selector: 'app-image-module',
  templateUrl: './image-module.component.html',
  styleUrls: ['./image-module.component.scss']
})


export class ImageModuleComponent implements OnInit {
  scale: number = 1;
  rotation: number = 0;
  posX: number = 0;
  posY: number = 0;
  lastX: number = 0;
  lastY: number = 0;
  isDragging: boolean = false;
  isFlipped: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AttendanceDetailComponent>
  ) { }

  ngOnInit(): void {
    this.resetView();
  }

  resetView(): void {
    this.scale = 0.6;
    this.rotation = 0;
    this.posX = 0;
    this.posY = 0;
    this.isFlipped = false;
  }

  close(): void {
    this.dialogRef.close();
  }

  rotate(): void {
    this.rotation += 90;
  }

  flipImage(): void {
    this.isFlipped = !this.isFlipped;
  }

  startDragging(event: MouseEvent | TouchEvent): void {
    this.isDragging = true;
    const clientX = this.getClientX(event);
    const clientY = this.getClientY(event);
    this.lastX = clientX;
    this.lastY = clientY;
  }

  stopDragging(): void {
    this.isDragging = false;
  }

  onDrag(event: MouseEvent | TouchEvent): void {
    if (!this.isDragging) return;
    const clientX = this.getClientX(event);
    const clientY = this.getClientY(event);
    this.posX += clientX - this.lastX;
    this.posY += clientY - this.lastY;
    this.lastX = clientX;
    this.lastY = clientY;
  }

  onWheel(event: WheelEvent): void {
    event.preventDefault();
    const zoomStep = 0.1;
    if (event.deltaY < 0) {
      this.scale = Math.min(this.scale + zoomStep, 5);
    } else {
      this.scale = Math.max(this.scale - zoomStep, 0.2);
    }
  }

  private getClientX(event: MouseEvent | TouchEvent): number {
    return (event instanceof MouseEvent) ? event.clientX : event.touches[0].clientX;
  }

  private getClientY(event: MouseEvent | TouchEvent): number {
    return (event instanceof MouseEvent) ? event.clientY : event.touches[0].clientY;
  }
  downloadImage(imageUrl: string): void {
      const fileName = imageUrl.split('/').pop(); // Extract filename from the URL
      this.saveImage(imageUrl, fileName || 'downloaded-image.jpg');
    }

    saveImage(url: string, fileName: string): void {
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          FileSaver.saveAs(blob, fileName);
        })
        .catch(error => console.error('Image download failed:',error));
      }


}